import React from 'react';
import { Link } from 'react-router-dom';
import { BookOpen, ArrowRight, Clock } from 'lucide-react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { DOCS_REGISTRY } from '../data/docsContent';

export default function DocsHubPage() {
  return (
    <div className="min-h-screen bg-bots-dark text-white font-sans">
      <Header />
      <section className="pt-32 pb-20 max-w-5xl mx-auto px-4">
        <div className="text-center mb-14">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-blue-500/10 border border-blue-500/20 text-blue-400 text-xs font-semibold uppercase tracking-wide mb-6">
            <BookOpen className="w-3.5 h-3.5" /> Documentation
          </div>
          <h1 className="text-4xl sm:text-5xl font-extrabold mb-4">AI Joomla Docs</h1>
          <p className="text-gray-400 max-w-2xl mx-auto">Installation guides, configuration reference and how-tos for every extension in the AI Joomla catalog.</p>
        </div>

        <div className="grid sm:grid-cols-2 gap-5" data-testid="docs-hub-grid">
          {DOCS_REGISTRY.map((doc) => (
            doc.comingSoon ? (
              <div key={doc.slug} className="bg-white/5 border border-white/10 rounded-2xl p-6 opacity-60" data-testid={`docs-card-${doc.slug}`}>
                <div className="flex items-center justify-between mb-3">
                  <h3 className="text-lg font-bold text-white">{doc.name}</h3>
                  <span className="inline-flex items-center gap-1 text-xs text-gray-400 border border-white/10 rounded-full px-2.5 py-1"><Clock className="w-3 h-3" /> Coming soon</span>
                </div>
                <p className="text-gray-500 text-sm mb-4">Full documentation for this extension is being written.</p>
                <Link to={doc.productLink} className="text-sm text-gray-400 hover:text-white inline-flex items-center gap-1" data-testid={`docs-card-${doc.slug}-product-link`}>
                  View product page <ArrowRight className="w-3.5 h-3.5" />
                </Link>
              </div>
            ) : (
              <Link
                key={doc.slug}
                to={`/docs/${doc.slug}`}
                className="group bg-white/5 border border-white/10 rounded-2xl p-6 hover:border-blue-400/40 hover:bg-blue-400/5 transition-all"
                data-testid={`docs-card-${doc.slug}`}
              >
                <h3 className="text-lg font-bold text-white mb-2 group-hover:text-blue-400 transition-colors">{doc.name}</h3>
                <p className="text-gray-400 text-sm mb-4">{doc.content?.tagline}</p>
                <span className="text-sm text-blue-400 inline-flex items-center gap-1 font-medium">
                  Read documentation <ArrowRight className="w-3.5 h-3.5 group-hover:translate-x-1 transition-transform" />
                </span>
              </Link>
            )
          ))}
        </div>
      </section>
      <Footer />
    </div>
  );
}
